(() => {
  const formatPrice = value => '$' + new Intl.NumberFormat('es-CL',{maximumFractionDigits:0}).format(Number(value));
  function initHeader(){
    const header=document.querySelector('.dnr-header');
    if(!header || header.dataset.ready)return;
    header.dataset.ready='true';
    const toggle=header.querySelector('[data-dnr-menu]');
    toggle?.addEventListener('click',()=>{
      const open=header.classList.toggle('dnr-menu-open');
      toggle.setAttribute('aria-expanded',String(open));
    });
    header.addEventListener('keydown',e=>{if(e.key==='Escape'){header.classList.remove('dnr-menu-open');toggle?.setAttribute('aria-expanded','false');}});
    const input=header.querySelector('[data-dnr-search-input]');
    const results=header.querySelector('[data-dnr-results]');
    if(!input || !results)return;
    let timer,controller;
    const close=()=>{results.hidden=true;input.setAttribute('aria-expanded','false');};
    input.addEventListener('input',()=>{
      clearTimeout(timer);controller?.abort();
      const query=input.value.trim();
      if(query.length<2){close();return;}
      timer=setTimeout(async()=>{
        controller=new AbortController();
        try{
          const params=new URLSearchParams({q:query,'resources[type]':'product','resources[limit]':'5','resources[options][unavailable_products]':'last'});
          const response=await fetch((window.Shopify?.routes?.root || '/')+'search/suggest.json?'+params,{signal:controller.signal});
          if(!response.ok)throw new Error('search');
          const data=await response.json();
          if(input.value.trim()!==query)return;
          results.replaceChildren();
          for(const item of data.resources?.results?.products || []){
            const link=document.createElement('a');link.className='dnr-suggestion';link.href=item.url;
            const image=document.createElement('img');image.src=typeof item.image==='string'?item.image:item.featured_image?.url || '';image.alt='';image.width=48;image.height=56;
            const detail=document.createElement('span');detail.textContent=item.title;
            if(item.price){const price=document.createElement('strong');price.textContent=formatPrice(item.price);detail.append(price);}
            if(image.getAttribute('src'))link.append(image);link.append(detail);results.append(link);
          }
          if(!results.childElementCount){const empty=document.createElement('p');empty.className='dnr-search-empty';empty.textContent=results.dataset.empty;results.append(empty);}
          const all=document.createElement('a');all.className='dnr-search-all';all.href=(window.Shopify?.routes?.root || '/')+'search?'+new URLSearchParams({q:query,type:'product','options[prefix]':'last'});all.textContent=results.dataset.all;results.append(all);
          results.hidden=false;input.setAttribute('aria-expanded','true');
        }catch(e){if(e.name!=='AbortError')close();}
      },220);
    });
    input.addEventListener('keydown',e=>{if(e.key==='Escape')close();if(e.key==='ArrowDown'&&!results.hidden){e.preventDefault();results.querySelector('a')?.focus();}});
    results.addEventListener('keydown',e=>{const links=[...results.querySelectorAll('a')];const i=links.indexOf(document.activeElement);if(e.key==='Escape'){close();input.focus();}if(e.key==='ArrowDown'){e.preventDefault();links[(i+1)%links.length]?.focus();}if(e.key==='ArrowUp'){e.preventDefault();if(i===0)input.focus();else links[i-1]?.focus();}});
    document.addEventListener('click',e=>{if(!header.querySelector('.dnr-search-wrap').contains(e.target))close();});
    header.addEventListener('focusout',()=>setTimeout(()=>{if(!header.querySelector('.dnr-search-wrap').contains(document.activeElement))close();},0));
  }

  // Keep the existing Bsale attribute contract and validate after every cart redraw.
  let taxDraft=null, saving=false;
  const fieldNames=['dte_rut','dte_razon_social','dte_giro','dte_direccion','dte_comuna','dte_ciudad','dte_email'];
  function capture(root){
    const data={dte_tipo:root.querySelector('[data-bsale-document-type]:checked')?.value || 'boleta'};
    for(const name of fieldNames)data[name]=root.querySelector(`[name="attributes[${name}]"]`)?.value.trim() || '';
    return data;
  }
  function sync(root){
    const invoice=root.querySelector('[data-bsale-document-type]:checked')?.value==='factura';
    root.querySelector('[data-bsale-invoice-fields]').hidden=!invoice;
    root.querySelectorAll('[data-bsale-invoice-field]').forEach(el=>el.required=invoice);
    if(!invoice)root.querySelector('[data-bsale-invoice-error]').hidden=true;
  }
  function initTax(){
    document.querySelectorAll('[data-bsale-tax-document-fields]:not([data-dnr-ready])').forEach(root=>{
      root.dataset.dnrReady='true';
      if(taxDraft){
        root.querySelectorAll('[data-bsale-document-type]').forEach(el=>el.checked=el.value===taxDraft.dte_tipo);
        for(const name of fieldNames){const el=root.querySelector(`[name="attributes[${name}]"]`);if(el)el.value=taxDraft[name] || '';}
      }
      sync(root);
    });
  }
  document.addEventListener('change',event=>{const root=event.target.closest('[data-bsale-tax-document-fields]');if(!root)return;sync(root);taxDraft=capture(root);});
  document.addEventListener('input',event=>{const root=event.target.closest('[data-bsale-tax-document-fields]');if(root)taxDraft=capture(root);});
  async function checkout(event){
    const trigger=event.type==='submit'?event.submitter:event.target.closest('button[name="checkout"],input[name="checkout"],a[href="/checkout"]');
    if(!trigger || (event.type==='submit' && trigger.name!=='checkout'))return;
    const scope=document.querySelector('cart-drawer.active') || document.querySelector('#main-cart-footer');
    const root=scope?.querySelector('[data-bsale-tax-document-fields]');
    if(!root)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(saving)return;
    const error=root.querySelector('[data-bsale-invoice-error]');const data=capture(root);
    if(data.dte_tipo==='factura'){
      const invalid=[...root.querySelectorAll('[data-bsale-invoice-field],input[type="email"]')].find(el=>!el.checkValidity());
      if(invalid){error.textContent='Completa los datos de factura antes de continuar.';error.hidden=false;invalid.focus();return;}
    }else{for(const name of fieldNames)data[name]='';}
    saving=true;trigger.disabled=true;trigger.setAttribute('aria-busy','true');
    try{
      const response=await fetch((window.Shopify?.routes?.root || '/')+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:data})});
      if(!response.ok)throw new Error('save');
      window.location.assign((window.Shopify?.routes?.root || '/')+'checkout');
    }catch{
      error.textContent='No pudimos guardar los datos tributarios. Intenta nuevamente.';error.hidden=false;saving=false;trigger.disabled=false;trigger.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click',checkout,true);document.addEventListener('submit',checkout,true);
  function init(){initHeader();initTax();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  const observer=new MutationObserver(records=>{if(records.some(r=>r.addedNodes.length))initTax();});
  observer.observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',init);
})();
